import { render } from "./pay-receipt.vue?vue&type=template&id=159690ff&scoped=true"
import script from "./pay-receipt.vue?vue&type=script&lang=js"
export * from "./pay-receipt.vue?vue&type=script&lang=js"

import "./pay-receipt.vue?vue&type=style&index=0&id=159690ff&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159690ff"]])

export default __exports__